import { useState } from "react";
import { useRouter } from "next/router";
import { Flex, HStack, Text } from "@chakra-ui/react";
import Link, { LinkProps } from "components/Link";
import Image from "components/Image";
import Button from "components/Button";
import { BurgerMenuIcon } from "components/Icons";
import Logo from "../../../public/logo-101digital-header.png";

const navItems = [
  {
    label: "Products",
    url: "/products",
  },
  {
    label: "Approach",
    url: "/approach",
  },
  {
    label: "Success Stories",
    url: "/success-stories",
  },
  {
    label: "People",
    url: "/people",
  },
];

const Header = () => {
  const router = useRouter();
  const [activeMobileMenu, setActiveMobileMenu] = useState(false);
  return (
    <Flex
      w="100%"
      mt={["28px", null, null, null, null, "16px"]}
      maxW={["100%", null, null, null, null, null]}
      align="center"
      justify={["center", null, null, null, null, "space-between"]}
      padding={[
        "0 16px",
        null,
        null,
        null,
        null,
        null,
        "0px 12%",
        null,
        "0px 16%",
        "0px 20%",
      ]}
      pos="relative"
    >
      <Link href="/" lineHeight="unset" display="flex">
        <Image src={Logo} alt="101Digital" />
      </Link>
      <Flex
        align="center"
        display="flex"
        flexDir={["column", null, null, null, null, "row"]}
        position={["fixed", null, null, null, null, "static"]}
        w={["100%", null, null, null, null, "auto"]}
        minH={["100vh", null, null, null, null, "0"]}
        top={0}
        left={0}
        bgColor="white"
        zIndex={[1, null, null, null, null, "auto"]}
        pt={["72px", null, null, null, null, "0"]}
        transition="0.3s ease"
        transform={[
          activeMobileMenu ? "translateX(0%)" : "translate(100%)",
          null,
          null,
          null,
          null,
          "translateX(0%)",
        ]}
      >
        <HStack
          spacing={["0", null, null, null, null, "32px"]}
          mr={["0", null, null, null, null, "46px"]}
          flexDir={["column", null, null, null, null, "row"]}
          w={["100%", null, null, null, null, "auto"]}
          borderTop={["1px solid #e7eaf8", null, null, null, null, "none"]}
        >
          <NavItem
            href="/"
            label="Home"
            onClick={() => setActiveMobileMenu(false)}
            display={["inline", null, null, null, null, "none"]}
          />
          {navItems.map((n, idx) => (
            <NavItem
              key={idx}
              href={n.url}
              label={n.label}
              onClick={() => setActiveMobileMenu(false)}
            />
          ))}
        </HStack>
        <Button
          href="/contact"
          w="188px"
          onClick={() => {
            router.push("/contact");
            setActiveMobileMenu(false);
          }}
          pos={["absolute", null, null, null, null, "static"]}
          top="16px"
          left="16px"
          height={["40px", null, null, null, null, "54px"]}
        >
          Talk to us
        </Button>
        <Text
          display={["block", null, null, null, null, "none"]}
          pos="absolute"
          top="24px"
          right="16px"
          onClick={() => setActiveMobileMenu(false)}
        >
          X
        </Text>
      </Flex>
      <BurgerMenuIcon
        display={["block", null, null, null, null, "none"]}
        pos="absolute"
        right="21px"
        onClick={() => setActiveMobileMenu(true)}
      />
    </Flex>
  );
};

interface NavItemProps extends Omit<LinkProps, "children"> {
  label: string;
}

const NavItem = ({ href, label, onClick, ...otherProps }: NavItemProps) => {
  const router = useRouter();
  return (
    <Link
      href={href}
      fontSize="1.125rem"
      fontWeight="700"
      lineHeight="1.75rem"
      color={[
        "primary",
        null,
        null,
        router.pathname == href ? "secondary" : "primary",
      ]}
      w={["100%", null, null, null, null, "auto"]}
      p={["16px", null, null, null, null, "0"]}
      onClick={onClick}
      {...otherProps}
    >
      {label}
    </Link>
  );
};

export default Header;
